import { createSelector } from 'reselect';

// selector
const getLogin = state => state.login;
// const getUserInfo = state => state.login.userInfo;
// reselect function
export const getLoginState = createSelector([getLogin], login => login);

export const getUserInfoSelector = createSelector([getLoginState], login => login.userInfo);
export const isEYProSelector = createSelector([getLoginState], login => login.userRoles.eyPro);
export const isEYAdminSelector = createSelector([getLoginState], login => login.userRoles.eyAdmin);
export const isApplicantSelector = createSelector([getLoginState], login => login.userRoles.applicant);
export const isCorpClientSelector = createSelector([getLoginState], login => login.userRoles.corpClient);
export const isEyEngagementAdminSelector = createSelector([getLoginState], login => login.userRoles.eyEngagementAdmin);
export const isCorporateClientLineManagerSelector = createSelector([getLoginState], login => login.userRoles.corporateClientlineManager);
export const isRestrictedCorpMemberSelector = createSelector([getLoginState], login => login.userRoles.restrictedCorpMember);

export const getUserRolesSelector = createSelector([getLoginState], login => login.userRoles);

export const getUserId = createSelector([getLoginState], login => login.userId);
